import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


export const getMockTestListSuccess = (data) => {
  return {
    type: actionTypes.GET_MOCK_TEST_LIST,
    payload: {
      mockTestList: data.Data,
    },
  };
};

export const getMockTestList = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GetMockTestList`, data)
    .then((response) => {
      if (response) {
        dispatch(getMockTestListSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
